class HotspotCarousel extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['index', 'title']
  }

  _titleHeight = 0

  constructor () {
    super()

    setTimeout(() => {
      this._titleHeight =
        this.setTitleHeight() === 0 ? 'auto' : `${this.setTitleHeight()}px`
      this.slidesEl.setAttribute(
        'style',
        `--Title_Height: ${this._titleHeight};`,
      )
    }, 250)
  }

  setupListeners () {
    super.setupListeners()

    if (!this.indexEls || !this.carouselEl) return

    this.listeners.add(this, 'click', this.handleClick.bind(this))

    this.debouncedOnSlideChange = window.BAO.Utils.debounce(event => {
      this.onSlideChange(event)
    }, 250)

    this.listeners.add(
      this.carouselEl,
      'SLIDE_CHANGED',
      this.debouncedOnSlideChange.bind(this),
    )

    this.listeners.add(window, 'resize', this.handleResize.bind(this))
  }

  handleClick (event) {
    const target = event.target
    const indexEl = target.closest(this.els.index.selector)
    if (!indexEl) return
    this.currentIndex = indexEl.dataset?.hotspotCarouselIndex
  }

  handleResize () {
    this._titleHeight =
      this.setTitleHeight() === 0 ? 'auto' : `${this.setTitleHeight()}px`
    this.slidesEl.setAttribute('style', `--Title_Height: ${this._titleHeight};`)
  }

  setTitleHeight () {
    let maxHeight = 0
    if (!this.isLg) return maxHeight
    this.titleEls.forEach(titleEl => {
      this.slidesEl.setAttribute('style', `--Title_Height: auto;`)
      const currentHeight = titleEl.getBoundingClientRect().height
      if (currentHeight <= maxHeight) return
      maxHeight = currentHeight
    })

    return maxHeight
  }

  onSlideChange (event) {
    const details = event?.detail?.track?.details
    if (!details) return
    this.currentIndex = details?.rel
  }

  get currentIndex () {
    return this._currentIndex
  }

  set currentIndex (index) {
    const indexInt = parseInt(index, 10)
    this._currentIndex = indexInt

    this.indexEls.forEach(indexEl => {
      const hotspotCarouselIndexInt = parseInt(
        indexEl.dataset?.hotspotCarouselIndex,
        10,
      )
      indexEl.setAttribute(
        'aria-current',
        (hotspotCarouselIndexInt === indexInt).toString(),
      )
    })

    if (!this.carouselEl || !this.carouselEl?._carousel) return
    const relInt = parseInt(this.carouselEl._carousel.track.details.rel, 10)
    if (relInt !== indexInt) {
      this.carouselEl._carousel.moveToIdx(indexInt)
    }
  }

  /*
  get externalIndexEls () {
    return this?.externalEls?.index?.elements
  }
  */

  get indexEls () {
    return this?.els?.index?.elements
  }

  get titleEls () {
    return this?.els?.title?.elements
  }

  get slidesEl () {
    return this?.els?.slides?.element
  }

  get carouselEl () {
    return window.BAO.Utils.getElement('global-carousel', { context: this })
  }

  get isLg () {
    return window.innerWidth > 1200
  }
}

if (!customElements.get('hotspot-carousel')) {
  customElements.define('hotspot-carousel', HotspotCarousel)
}
